import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VariantType } from 'notistack';
import { IRootState } from '@app/store';

export interface INotification {
  message: string;
  variant: VariantType;
}

export interface INotificationState {
  notification: INotification | null;
}

const initialState: INotificationState = {
  notification: null,
};

export const selectNotification = (state: IRootState) =>
  state.notification.notification;

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setNotification: (state, action: PayloadAction<INotification | null>) => {
      state.notification = action.payload;
    },
  },
});

export const { setNotification } = notificationSlice.actions;

export default notificationSlice.reducer;
